import request from '../utils/request';

export function getRoleList(params) {
  return request.get('/role/list', { params });
}

export function getRoleAll(params) {
  return request.get('/role/all');
}

export function getUserList(params) {
  return request.get('/user/list', { params });
}

export function createUser(data) {
  return request.post('/user/create', data);
}

export function updateUser(data) {
  return request.put('/user/update', data);
}

export function deleteUser(id) {
  return request.delete('/user/delete', { params: { id } });
}
